import React from 'react';
import { PasswordInput } from '../../../../../../public/pages/auth/register/components/PasswordInput';

export const MyProfileSecurityCard = ({
    currentPassword,
    newPassword,
    confirmPassword,
    onCurrentPasswordChange,
    onNewPasswordChange,
    onConfirmPasswordChange,
    passwordRules,
    onSubmit,
    isChangingPassword,
}) => {
    return (
        <div className="card card__no-border profile-card-surface">
            <div className="card-body p-4">
                <h6 className="fw-semibold mb-3">Seguridad</h6>

                <form onSubmit={onSubmit}>
                    <div className="row g-3">
                        <div className="col-md-4">
                            <label className="form-label">Contraseña actual</label>
                            <PasswordInput
                                name="currentPassword"
                                placeholder="Contraseña actual"
                                value={currentPassword}
                                onChange={(event) => onCurrentPasswordChange(event.target.value || '')}
                                showGenerator={false}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Nueva contraseña</label>
                            <PasswordInput
                                name="newPassword"
                                placeholder="Nueva contraseña"
                                value={newPassword}
                                onChange={(event) => onNewPasswordChange(event.target.value || '')}
                                showGenerator
                            />
                            <div className="profile-password-rules mt-2">
                                {passwordRules.map((rule) => (
                                    <div key={rule.key} className={`profile-password-rules__item ${rule.valid ? 'is-valid' : ''}`}>
                                        <i className={`bi ${rule.valid ? 'bi-check-circle-fill' : 'bi-circle'}`} aria-hidden="true" />
                                        <span>{rule.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Confirmar contraseña</label>
                            <PasswordInput
                                name="confirmPassword"
                                placeholder="Confirmar contraseña"
                                value={confirmPassword}
                                onChange={(event) => onConfirmPasswordChange(event.target.value || '')}
                                showGenerator={false}
                            />
                            <div className="fs-12 mt-2">
                                {confirmPassword && newPassword === confirmPassword
                                    ? <span className="text-success">La confirmación coincide.</span>
                                    : <span className="text-muted">Confirma la nueva contraseña.</span>}
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 d-flex justify-content-end">
                        <button type="submit" className="btn btn-primary" disabled={isChangingPassword}>
                            {isChangingPassword ? 'Actualizando...' : 'Cambiar contraseña'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
